module.exports = __webpack_public_path__ + "img/index.188e6961.jpg";